export const HOME_CHANNEL_BUTTON_CLICKED = 'home-channel-button-clicked';
export const HOME_ADD_TEAM_BUTTON_CLICKED = 'home-add-team-button-clicked';
export const HOME_USER_SHORTCUT_CLICKED = 'home-user-shortcut-clicked';
export const HOME_MESSAGE_RECEIVED_SHORTCUT_CLICKED = 'home-message-received-shortcut-clicked';
export const HOME_MESSAGE_SENT_SHORTCUT_CLICKED = 'home-message-sent-shortcut-clicked';
export const HOME_PREFERENCES_APPLIED = 'home-preferences-applied';
export const STEP_CHECKED_TRACK_NAME = 'home-checklist-checked';
export const CHECKLIST_COMPLETED_TRACK_NAME = 'home-checklist-completed';
export const HOME_TEMPLATE_DOCUMENTATION_OPENED = 'home-template-documentation-opened';
export const HOME_AI_BUTTON_CLICKED = 'home-ai-button-clicked';
export const HOME_APPLICATION_OPENED = 'home-chatbot-opened';
